<template>
<div class="dialog">
<div class="mask"></div>
 <div class="dialog-content">
    <p class="text F1-M-24" v-html="modal.text" style="margin-top:8%;margin-bottom:7%"></p>
     <div class="btn-group" style="margin-bottom:1%">
       <div style="width:40%">
        <button class="btn btn-default F2-M-24 bgc1" @click="submit">{{ modal.confirmButtonText }}</button>
       </div>
      <div v-if="modal.showNo" class="divMargin" style="width:40%">
        <button  class="btn btn-default F2-M-24 bgc1" @click="cancel">
          {{ modal.cancelButtonText }}
        </button>
      </div>
     </div>
</div>
</div>
</template>

<script>
export default {
  name: 'messageDialog',
  props: {
    dialogOption: Object
  },
  data () {
    return {
      resolve: '',
      reject: '',
      promise: '' // 保存promise对象
    }
  },
  computed: {
    modal: function () {
      let options = this.dialogOption
      return {
        showNo: options.showNo || false,
        text: options.text,
        cancelButtonText: options.cancelButtonText
          ? options.cancelButtonText
          : 'いいえ',
        confirmButtonText: options.confirmButtonText
          ? options.confirmButtonText
          : 'はい'
      }
    }
  },
  methods: {
    // 确定,将promise断定为完成态
    submit () {
      this.resolve('submit')
    },
    // 取消,将promise断定为reject状态
    cancel () {
      this.reject('cancel')
    },
    // 显示confirm弹出,并创建promise对象，给父组件调用
    confirm () {
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
      return this.promise // 返回promise对象,给父级组件调用
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  .dialog-content {
    position: relative;
    top: 30%;
    left: 20%;
    margin: 0px auto;
    position: fixed;
    box-sizing: border-box;
    width: 55%;
    border-radius: 5px;
    background: #fff;
    z-index: 50002;
    .btn-group {
      display: flex;
      bottom: 10px;
      justify-content:center;
      .btn {
        padding: 0;
        width: 100%;
        border-radius: 10px;
        height: 40px;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50001;
    background: rgba(0, 0, 0, 0.5);
  }
  .divMargin{
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog.vue